import '../LinkCopiedNotification/LinkCopiedNotification.css';
import { useTranslation } from 'react-i18next';

const DeleteFavoriteNotification = () => {
	const { t } = useTranslation();
	return (
		<div>
			<p className='text-small-notification blue-aquinas-text '>
				{t('Successfully deleted')}
			</p>
		</div>
	);
};
export default DeleteFavoriteNotification;
